import React, { useState } from 'react';
import Header from '../components/Header';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';

interface FormData {
    nom: string;
    email: string;
    telephone: string;
    sujet: string;
    message: string;
}

const Contact: React.FC = () => {
    const [formData, setFormData] = useState<FormData>({
        nom: '',
        email: '',
        telephone: '',
        sujet: '',
        message: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);

        // Simulate form submission
        setTimeout(() => {
            setIsSubmitting(false);
            setIsSubmitted(true);
            console.log('Form submitted:', formData);
        }, 1500);
    };

    const contactInfo = [
        {
            icon: (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
            ),
            title: 'Adresse',
            content: '26 Bd Henri Sellier',
            subcontent: '92150 Suresnes, France',
            link: 'https://maps.google.com/?q=26+Bd+Henri+Sellier+92150+Suresnes'
        },
        {
            icon: (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
            ),
            title: 'Téléphone',
            content: '01 23 45 67 89',
            subcontent: 'Du lundi au samedi',
            link: 'tel:+33123456789'
        },
        {
            icon: (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
            ),
            title: 'Email',
            content: 'contact@podium-cycling.fr',
            subcontent: 'Réponse sous 24h',
            link: 'mailto:contact@podium-cycling.fr'
        }
    ];

    const horaires = [
        { jour: 'Lundi', heures: '10h00 - 19h00' },
        { jour: 'Mardi', heures: '10h00 - 19h00' },
        { jour: 'Mercredi', heures: '10h00 - 19h00' },
        { jour: 'Jeudi', heures: '10h00 - 19h00' },
        { jour: 'Vendredi', heures: '10h00 - 19h00' },
        { jour: 'Samedi', heures: '09h00 - 18h00' },
        { jour: 'Dimanche', heures: 'Fermé' }
    ];

    const today = new Date().getDay();
    const jourActuel = today === 0 ? 6 : today - 1; // Adjust for Monday start

    return (
        <div className="min-h-screen bg-white">
            <Header />

            {/* Hero Section */}
            <section className="relative pt-24 md:pt-32 pb-16 md:pb-24 overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-zinc-900 via-zinc-800 to-zinc-900"></div>
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute inset-0" style={{
                        backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23ffffff' fill-opacity='0.1' fill-rule='evenodd'/%3E%3C/svg%3E")`,
                    }}></div>
                </div>

                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
                        Contactez-nous
                    </h1>
                    <p className="text-xl text-zinc-300 max-w-2xl mx-auto mb-10">
                        Une question sur nos services ? Besoin d'un conseil ?
                        Notre équipe est à votre disposition pour vous accompagner.
                    </p>

                    {/* Quick Contact Cards */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-4xl mx-auto">
                        {contactInfo.map((info, index) => (
                            <a
                                key={index}
                                href={info.link}
                                target={info.link.startsWith('http') ? '_blank' : undefined}
                                rel={info.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                                className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all duration-300 group"
                            >
                                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4 text-white group-hover:scale-110 transition-transform">
                                    {info.icon}
                                </div>
                                <h3 className="font-semibold text-white mb-1">{info.title}</h3>
                                <p className="text-white font-medium">{info.content}</p>
                                <p className="text-zinc-400 text-sm">{info.subcontent}</p>
                            </a>
                        ))}
                    </div>
                </div>
            </section>

            {/* Main Content */}
            <section className="py-16 md:py-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">

                        {/* Contact Form */}
                        <div>
                            <div className="mb-8">
                                <h2 className="text-3xl font-bold text-zinc-900 mb-4">Envoyez-nous un message</h2>
                                <p className="text-zinc-600">
                                    Remplissez le formulaire ci-dessous et nous vous répondrons dans les plus brefs délais.
                                </p>
                            </div>

                            {isSubmitted ? (
                                <div className="bg-green-50 border border-green-200 rounded-2xl p-8 text-center">
                                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                        <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                        </svg>
                                    </div>
                                    <h3 className="text-xl font-bold text-green-800 mb-2">Message envoyé !</h3>
                                    <p className="text-green-700">Nous vous répondrons dans les plus brefs délais.</p>
                                    <button
                                        onClick={() => {
                                            setIsSubmitted(false);
                                            setFormData({ nom: '', email: '', telephone: '', sujet: '', message: '' });
                                        }}
                                        className="mt-4 text-green-600 hover:text-green-700 font-medium underline"
                                    >
                                        Envoyer un autre message
                                    </button>
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit} className="space-y-6">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-semibold text-zinc-700 mb-2">
                                                Nom complet <span className="text-red-500">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="nom"
                                                value={formData.nom}
                                                onChange={handleInputChange}
                                                required
                                                placeholder="Jean Dupont"
                                                className="w-full px-4 py-3 border-2 border-zinc-200 rounded-xl focus:ring-2 focus:ring-zinc-900 focus:border-transparent transition-all"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-semibold text-zinc-700 mb-2">
                                                Email <span className="text-red-500">*</span>
                                            </label>
                                            <input
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                                required
                                                placeholder="jean@exemple.fr"
                                                className="w-full px-4 py-3 border-2 border-zinc-200 rounded-xl focus:ring-2 focus:ring-zinc-900 focus:border-transparent transition-all"
                                            />
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-semibold text-zinc-700 mb-2">
                                                Téléphone
                                            </label>
                                            <input
                                                type="tel"
                                                name="telephone"
                                                value={formData.telephone}
                                                onChange={handleInputChange}
                                                placeholder="06 12 34 56 78"
                                                className="w-full px-4 py-3 border-2 border-zinc-200 rounded-xl focus:ring-2 focus:ring-zinc-900 focus:border-transparent transition-all"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-sm font-semibold text-zinc-700 mb-2">
                                                Sujet <span className="text-red-500">*</span>
                                            </label>
                                            <select
                                                name="sujet"
                                                value={formData.sujet}
                                                onChange={handleInputChange}
                                                required
                                                className="w-full px-4 py-3 border-2 border-zinc-200 rounded-xl focus:ring-2 focus:ring-zinc-900 focus:border-transparent transition-all bg-white"
                                            >
                                                <option value="">Sélectionnez un sujet</option>
                                                <option value="etude-posturale">Étude posturale</option>
                                                <option value="location">Location de vélo</option>
                                                <option value="lavage">Lavage vélo</option>
                                                <option value="atelier">Atelier / Réparation</option>
                                                <option value="produits">Produits / Achat</option>
                                                <option value="autre">Autre demande</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-semibold text-zinc-700 mb-2">
                                            Message <span className="text-red-500">*</span>
                                        </label>
                                        <textarea
                                            name="message"
                                            value={formData.message}
                                            onChange={handleInputChange}
                                            required
                                            rows={5}
                                            placeholder="Décrivez votre demande..."
                                            className="w-full px-4 py-3 border-2 border-zinc-200 rounded-xl focus:ring-2 focus:ring-zinc-900 focus:border-transparent transition-all resize-none"
                                        />
                                    </div>

                                    <button
                                        type="submit"
                                        disabled={isSubmitting}
                                        className={`w-full py-4 rounded-xl font-semibold text-lg transition-all duration-300 flex items-center justify-center gap-2 ${isSubmitting
                                            ? 'bg-zinc-400 cursor-not-allowed'
                                            : 'bg-zinc-900 hover:bg-zinc-800 text-white shadow-lg hover:shadow-xl'
                                            }`}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <svg className="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                                Envoi en cours...
                                            </>
                                        ) : (
                                            <>
                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                                                </svg>
                                                Envoyer le message
                                            </>
                                        )}
                                    </button>
                                </form>
                            )}
                        </div>

                        {/* Info & Map */}
                        <div className="space-y-8">
                            {/* Horaires */}
                            <div className="bg-zinc-50 rounded-2xl p-6">
                                <h3 className="text-xl font-bold text-zinc-900 mb-4 flex items-center gap-2">
                                    <svg className="w-6 h-6 text-zinc-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    Horaires d'ouverture
                                </h3>
                                <div className="space-y-2">
                                    {horaires.map((h, index) => (
                                        <div
                                            key={index}
                                            className={`flex justify-between items-center py-2 px-3 rounded-lg ${index === jourActuel ? 'bg-zinc-900 text-white' : ''
                                                }`}
                                        >
                                            <span className={`font-medium ${index === jourActuel ? 'text-white' : 'text-zinc-700'}`}>
                                                {h.jour}
                                                {index === jourActuel && <span className="ml-2 text-xs bg-white/20 px-2 py-0.5 rounded-full">Aujourd'hui</span>}
                                            </span>
                                            <span className={`${h.heures === 'Fermé' ? 'text-red-500' : index === jourActuel ? 'text-zinc-200' : 'text-zinc-600'}`}>
                                                {h.heures}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Map */}
                            <div className="rounded-2xl overflow-hidden shadow-lg">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2625.1234567890123!2d2.2234567890123456!3d48.87123456789012!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e665a3c2d99b93%3A0x1234567890abcdef!2s26%20Bd%20Henri%20Sellier%2C%2092150%20Suresnes!5e0!3m2!1sfr!2sfr!4v1234567890123!5m2!1sfr!2sfr"
                                    width="100%"
                                    height="300"
                                    style={{ border: 0 }}
                                    allowFullScreen
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Localisation Podium"
                                    className="w-full"
                                ></iframe>
                                <div className="bg-white p-4">
                                    <a
                                        href="https://maps.google.com/?q=26+Bd+Henri+Sellier+92150+Suresnes"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex items-center justify-center gap-2 w-full py-3 bg-zinc-100 hover:bg-zinc-200 rounded-lg text-zinc-700 font-medium transition-colors"
                                    >
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                        </svg>
                                        Ouvrir dans Google Maps
                                    </a>
                                </div>
                            </div>

                            {/* Réseaux sociaux */}
                            <div className="bg-zinc-900 rounded-2xl p-6 text-white">
                                <h3 className="text-xl font-bold mb-4">Suivez-nous</h3>
                                <p className="text-zinc-400 mb-4">Restez connectés avec nous sur les réseaux sociaux</p>
                                <div className="flex gap-4">
                                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors">
                                        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                                        </svg>
                                    </a>
                                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors">
                                        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                                        </svg>
                                    </a>
                                    <a href="https://strava.com" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors">
                                        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0l-7 13.828h4.169" />
                                        </svg>
                                    </a>
                                    <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors">
                                        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Services Section */}
            <section className="py-16 bg-zinc-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h2 className="text-3xl font-bold text-center text-zinc-900 mb-12">Nos services</h2>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        <a href="/etude-posturale" className="bg-white rounded-xl p-6 shadow-sm hover:shadow-lg transition-all group">
                            <div className="w-14 h-14 bg-zinc-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-zinc-900 group-hover:text-white transition-colors">
                                <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                </svg>
                            </div>
                            <h3 className="font-bold text-lg text-zinc-900 mb-2">Étude Posturale</h3>
                            <p className="text-zinc-600 text-sm">Optimisez votre position pour plus de performance et de confort.</p>
                        </a>

                        <a href="/location" className="bg-white rounded-xl p-6 shadow-sm hover:shadow-lg transition-all group">
                            <div className="w-14 h-14 bg-zinc-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-zinc-900 group-hover:text-white transition-colors">
                                <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                            </div>
                            <h3 className="font-bold text-lg text-zinc-900 mb-2">Location Vélo</h3>
                            <p className="text-zinc-600 text-sm">Louez un vélo haut de gamme pour vos sorties et compétitions.</p>
                        </a>

                        <a href="/lavage-velo" className="bg-white rounded-xl p-6 shadow-sm hover:shadow-lg transition-all group">
                            <div className="w-14 h-14 bg-zinc-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-zinc-900 group-hover:text-white transition-colors">
                                <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
                                </svg>
                            </div>
                            <h3 className="font-bold text-lg text-zinc-900 mb-2">Lavage Vélo</h3>
                            <p className="text-zinc-600 text-sm">Service de lavage professionnel pour votre vélo.</p>
                        </a>

                        <a href="/atelier-velo" className="bg-white rounded-xl p-6 shadow-sm hover:shadow-lg transition-all group">
                            <div className="w-14 h-14 bg-zinc-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-zinc-900 group-hover:text-white transition-colors">
                                <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                            </div>
                            <h3 className="font-bold text-lg text-zinc-900 mb-2">Atelier & Réparation</h3>
                            <p className="text-zinc-600 text-sm">Montage sur mesure, révision et réparation de vélos.</p>
                        </a>
                    </div>
                </div>
            </section>

            {/* Notre Boutique Section */}
            <section className="py-16">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                        <div>
                            <h2 className="text-3xl font-bold text-zinc-900 mb-6">Notre boutique</h2>
                            <p className="text-zinc-600 mb-6 leading-relaxed">
                                Bienvenue chez Podium, votre spécialiste du cyclisme haut de gamme à Suresnes.
                                Notre espace de 150m² vous accueille dans une ambiance moderne et chaleureuse,
                                où passion et expertise se rencontrent.
                            </p>
                            <p className="text-zinc-600 mb-8 leading-relaxed">
                                Que vous soyez cycliste amateur ou compétiteur confirmé, notre équipe de passionnés
                                est là pour vous conseiller et vous accompagner dans tous vos projets vélo.
                            </p>
                            <div className="flex flex-wrap gap-4">
                                <div className="flex items-center gap-2 bg-zinc-100 px-4 py-2 rounded-lg">
                                    <svg className="w-5 h-5 text-zinc-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    <span className="text-zinc-700 font-medium">Vélos haut de gamme</span>
                                </div>
                                <div className="flex items-center gap-2 bg-zinc-100 px-4 py-2 rounded-lg">
                                    <svg className="w-5 h-5 text-zinc-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    <span className="text-zinc-700 font-medium">Équipements premium</span>
                                </div>
                                <div className="flex items-center gap-2 bg-zinc-100 px-4 py-2 rounded-lg">
                                    <svg className="w-5 h-5 text-zinc-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    <span className="text-zinc-700 font-medium">Atelier spécialisé</span>
                                </div>
                                <div className="flex items-center gap-2 bg-zinc-100 px-4 py-2 rounded-lg">
                                    <svg className="w-5 h-5 text-zinc-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    <span className="text-zinc-700 font-medium">Conseils experts</span>
                                </div>
                            </div>
                        </div>
                        <div className="relative">
                            <div className="rounded-2xl overflow-hidden shadow-2xl">
                                <img
                                    src="/PodiumCC.png"
                                    alt="Boutique Podium Cycling"
                                    className="w-full h-auto object-cover"
                                />
                            </div>
                            {/* Decorative element */}
                            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-zinc-900 rounded-2xl -z-10"></div>
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ */}
            <section className="py-16 bg-zinc-50">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h2 className="text-3xl font-bold text-center text-zinc-900 mb-12">Questions fréquentes</h2>

                    <div className="space-y-4">
                        <details className="group bg-zinc-50 rounded-xl">
                            <summary className="flex items-center justify-between p-6 cursor-pointer list-none">
                                <span className="font-semibold text-zinc-900">Comment prendre rendez-vous ?</span>
                                <svg className="w-5 h-5 text-zinc-500 group-open:rotate-180 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                            </summary>
                            <div className="px-6 pb-6 text-zinc-600">
                                Vous pouvez prendre rendez-vous directement via notre site web pour l'étude posturale, la location de vélo ou le lavage. Pour l'atelier, contactez-nous par téléphone ou par email.
                            </div>
                        </details>

                        <details className="group bg-zinc-50 rounded-xl">
                            <summary className="flex items-center justify-between p-6 cursor-pointer list-none">
                                <span className="font-semibold text-zinc-900">Où êtes-vous situés ?</span>
                                <svg className="w-5 h-5 text-zinc-500 group-open:rotate-180 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                            </summary>
                            <div className="px-6 pb-6 text-zinc-600">
                                Notre boutique est située au 26 Boulevard Henri Sellier, 92150 Suresnes, facilement accessible en transports en commun (Tramway T2, arrêt Suresnes Longchamp).
                            </div>
                        </details>

                        <details className="group bg-zinc-50 rounded-xl">
                            <summary className="flex items-center justify-between p-6 cursor-pointer list-none">
                                <span className="font-semibold text-zinc-900">Quels types de vélos prenez-vous en charge ?</span>
                                <svg className="w-5 h-5 text-zinc-500 group-open:rotate-180 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                            </summary>
                            <div className="px-6 pb-6 text-zinc-600">
                                Nous sommes spécialisés dans les vélos de route, de triathlon et de gravel. Nous ne prenons pas en charge les vélos de ville, les VAE (vélos électriques) et les trottinettes.
                            </div>
                        </details>

                        <details className="group bg-zinc-50 rounded-xl">
                            <summary className="flex items-center justify-between p-6 cursor-pointer list-none">
                                <span className="font-semibold text-zinc-900">Proposez-vous un parking ?</span>
                                <svg className="w-5 h-5 text-zinc-500 group-open:rotate-180 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                            </summary>
                            <div className="px-6 pb-6 text-zinc-600">
                                Oui, un parking est disponible à proximité de la boutique. Des emplacements vélo sécurisés sont également disponibles devant notre enseigne.
                            </div>
                        </details>
                    </div>
                </div>
            </section>

            <Newsletter />
            <Footer />
        </div>
    );
};

export default Contact;
